module.exports = __webpack_public_path__ + "static/img/zhutu环卫车.6e6f0f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhutu环卫车.png
// module id = Y104
// module chunks = 0